<!--It is created by Shyam 19-02-2025-->
<!--Functional Mapping component-->
<div class="topDiv" [style.background-color]="backgroundColorScreen">
    <div class="agGridOuterDiv">
    <div>
    <mat-toolbar
              class="agGridtoperDiv card"
              style="background: rgb(228 227 230 / 41%); border-top: 1px solid #a9a9a9a8; border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8;">
    <label i18n="@@spmsUserReg" class="textColour">Functional Mapping</label>
    <span class="example-spacer"></span>
     
              <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="buttonColor"
              title="Update"
              (click)="onEdit()">
        Update
    <em style="padding: 0px 0px 0px 10px;" class="fas fa-edit" title="Map"></em>
    </button> -->
    <!-- Refresh Button -->
    <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                      [style.background-color]="buttonColor"
                      title="Refresh"
                      (click)="onRefresh()">
                Refresh
    <em style="padding: 0px 0px 0px 10px;" class="fas fa-sync" title="Refresh"></em>
    </button>
    <!-- Hidden file input for CSV upload -->
    <input type="file" #fileInput  style="display: none;" (change)="mappingFile($event, 'filecheck')">
    <!-- Upload File Button -->
    <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                      [style.background-color]="buttonColor"
                      title="Upload File"
                      (click)="fileInput.click()">
                Upload File
    <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
    </button>
    <!-- Download Button -->
    <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                      [style.background-color]="buttonColor"
                      title="Download"
                      (click)="onBtExport()">
                Download
    <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
    </button>
    <div class="insertPageNoDiv">
    <mat-form-field appearance="outline">
    <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
    <input matInput type="text" (input)="onSearchChange($event.target.value)">
    </mat-form-field>
    </div>
    <div class="selectRecordsDiv" style="width:9.5%">
    <mat-form-field appearance="outline" style="width:100%">
    <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
    <mat-select [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged()">
    <mat-option value="10" selected>10</mat-option>
    <mat-option value="200">200</mat-option>
    <mat-option value="300">300</mat-option>
    <mat-option value="400">400</mat-option>
    </mat-select>
    </mat-form-field>
    </div>
    <div class="card pagination paginationFirstButton paginationFirstlastButton">
    <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
    </div>
    <div class="card pagination paginationButtons btn-rounded">
    <ul>
    <li class="paginationliicon">
    <em class="fas fa-angle-left waves-effect waves-light" (click)="onBtPrevious()"></em>
    </li>
    <li>{{currentpage}}/{{totalpages}}</li>
    <li class="paginationliicon" style="padding:0;">
    <em class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em>
    </li>
    </ul>
    </div>
    <div class="card pagination paginationLastButton paginationFirstlastButton">
    <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
    </div>
    </mat-toolbar>
    </div>
    <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
                            [columnDefs]="columnDefs" [animateRows]="true"
                            [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
                            [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"
                            [floatingFiltersHeight]="45" [paginationPageSize]="paginationPageSize"
                            [paginationNumberFormatter]="paginationNumberFormatter"
                            [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
                            (paginationChanged)="onPaginationChanged()"
                            [components]="components"
                            [rowSelection]="rowSelection"
                            (gridReady)="onGridReady($event)" [hidden]="!true">
    </ag-grid-angular>
    </div>